module.exports = __webpack_public_path__ + "img/tea.2f3bbcac.svg";